<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('paymentApplyListAdd.billInfo.title') }}</div
          >
        </template>
        <div class="collapse-content">
          <BillInfo
            v-bind:feeInfo="feeInfo"
            :canEdit="canEdit"
            :currencyList="currencyList"
            :companyList="companyList"
            :query="query"
            :canEditSettlementBusinessType="canEditSettlementBusinessType"
            @getInvoiceCodes="getInvoiceCodes"
            @resetRowInfo="resetRowInfo"
            @clearBillCertList="clearBillCertList"
            @updateForm="updateForm"
            @settlementBusinessTypeHandler="settlementBusinessTypeHandler"
            :getPayapplyLine="getPayapplyLine"
            ref="feeInfo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('paymentApplyListAdd.invoiceLine.title') }}</div
          >
        </template>
        <div class="collapse-content">
          <payapplyLine
            :canEdit="canEdit"
            :validateForm="validateForm"
            :departmentList="departmentList"
            ref="payapplyLineInfo"
            :exchangeRate="feeInfo.exchangeRate"
            :payApplyDetailList="fundPayableList"
            :feeInfo="feeInfo"
            :invoiceCodeList="invoiceCodeList"
            :invoiceCode="query && query.invoiceCode"
            :defaultSettlementBusinessType="settlementBusinessType"
            @getTaxRateList="(list) => (this.taxRateList = list)"
            @updateDelList="(list) => (this.delList = list)"
            @attachmentUpdate="attachmentUpdate"
            @getDetail="getDetail"
            @updateBillInfo="updateBillInfo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item
        name="3"
        v-if="['013', '012', '017', '10', '016', '015'].includes(this.feeInfo.paymentMethod)"
      >
        <template slot="title">
          <div class="collapse-title-pre"><span></span>票据信用证</div>
        </template>
        <div class="collapse-content">
          <BillCertList :canEdit="canEdit" :feeInfo="feeInfo" ref="billCertListRef" />
        </div>
      </el-collapse-item>

      <el-collapse-item name="4" v-if="this.$route.query?.isEdit != 'Y'">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>抵扣情况</div>
        </template>
        <div class="collapse-content">
          <deduction-info ref="deductionInfo" :deductionInfoList="deductionInfoList" />
        </div>
      </el-collapse-item>

      <el-collapse-item name="5" v-if="payOrderDetailList[0]">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>付款信息</div>
        </template>
        <div class="collapse-content">
          <payOrderLine :payOrderDetailList="payOrderDetailList" ref="payOrderLineInfo" />
        </div>
      </el-collapse-item>

      <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('applicationDetail.collapseTitle.fileTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <!-- <upload
            ref="upload"
            :isShow="
              canEdit &&
              ['', 'Saved', 'Withdraw', 'Rejected', 'Approved', 'Freeze'].indexOf(
                feeInfo.requestStatus
              ) != -1
            "
            defaultPath="scm/paymentApply"
            :tableData="attachmentList"
            @upload="uploadList"
          /> -->
          <FileTable
            ref="fileTableRef"
            :attachments="attachmentList"
            :isShowDownBtn="
              !(
                canEdit &&
                ['', 'Saved', 'Withdraw', 'Rejected', 'Approved', 'Freeze'].indexOf(
                  feeInfo.requestStatus
                ) != -1
              )
            "
            defaultPath="scm/paymentApply"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="showGenerateAttachments"
        :disabled="disableAttachment"
        type="primary"
        @click="generateAttachment"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ '生成附件' }}</el-button
      >
      <el-button
        v-hasPermi="['2021050810400861027']"
        :disabled="
          (['Saved', 'Withdraw', 'Rejected', 'Freeze'].indexOf(feeInfo.requestStatus) == -1 &&
            !canEdit) ||
          !feeInfo.requestStatus
        "
        type="primary"
        @click="edit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.edit') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810403031280']"
        :disabled="
          ['', 'Saved', 'Withdraw', 'Rejected', 'Approved', 'Freeze'].indexOf(
            feeInfo.requestStatus
          ) == -1 || !canEdit
        "
        type="primary"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('paymentApplyListAdd.btns.save') }}</el-button
      >

      <!-- 提交按钮  已提交状态单据跟其他状态判断不一致 -->
      <el-button
        v-hasPermi="['2021050810412999571']"
        :disabled="
          ['', 'Saved', 'Withdraw', 'Rejected', 'Approved', 'Freeze'].indexOf(
            feeInfo.requestStatus
          ) == -1 || !canEdit
        "
        type="primary"
        @click="submitApproval"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('paymentApplyListAdd.btns.approval') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050810405486535']"
        :disabled="['Approving'].indexOf(feeInfo.requestStatus) == -1"
        type="primary"
        @click="doWithdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('paymentApplyListAdd.btns.doWithdraw') }}</el-button
      >
      <el-button
        v-if="['物贸', '城矿'].includes(userInfo.businessGroup)"
        :disabled="
          ['', 'Saved', 'Withdraw', 'Rejected', 'Approved', 'Freeze'].indexOf(
            feeInfo.requestStatus
          ) == -1 || !canEdit
        "
        type="primary"
        @click="submitTemporaryQuota"
        :loading="load"
        class="fixed-bottom-btn"
        >申请项目临时额度</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BillCertList from '@/pages/financeCenter/payment/chengKuangApply/components/billCertList';
  import BillInfo from './components/billInfo';
  import payapplyLine from './components/payapplyLine';
  import payOrderLine from './components/paymentOrder';
  import deductionInfo from './components/deductionInfo';
  import DataBaseAPI from '@/api/dataBase';
  import APLAY_LIST from '@/api/financeCenter/paymentApply';
  import loading from '@/common/js/load.js'; //loading
  import XEUtils from 'xe-utils';
  export default {
    components: {
      BillInfo,
      BillCertList,
      payapplyLine,
      payOrderLine,
      deductionInfo,
    },
    name: 'paymentApplyAddCK',
    data() {
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        activeNameTab: 'first',
        id: null,
        load: false,
        flag: this.$route.query.flag,
        activeNames: ['1', '2', '3', '4', '5', '6'], //默认展开那些面板，
        orderInfo: {},
        feeInfo: {
          invoiceType: 'invoice',
          fundPaymentApplyDetailList: [],
          exchangeRateDate: date,
          requestDate: date, //申请日期
          exchangeRate: null,
          requestStatus: '',
        },
        type: false,
        companyList: [], //公司列表
        departmentList: [], // 部门列表
        taxRateList: [], //率
        companyTree: [], // 部门数
        invoiceCodeList: [], //发票号列表
        requestCompanyCode: '', //申请公司code
        delList: [], // 行删除列表
        feeInfoList: [],
        query: null, //发票传参
        attachmentList: [],
        canEdit: this.$route.query.isEdit == 'Y',
        payOrderDetailList: [], //付款单信息
        deductionInfoList: [],
        settlementBusinessType: '',
        canEditSettlementBusinessType: true,
        projectId: '',
        deficientLimit: '',
        isSaveSuccess: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        currencyList() {
          return this.$baseRequest.getDictListMapByType('all_currency');
        },
      }),
      disableAttachment() {
        let id = this.$route.query.id;
        if (!id || id?.length == 0) {
          id = this.id;
        }
        if (!id || id?.length == 0) {
          return true;
        }
        return ['', 'Approving', 'Approved'].includes(this.feeInfo.requestStatus);
      },
      showGenerateAttachments() {
        return this.feeInfo.isRelatedInstruction == '1';
      },
      // 计算发票行汇率
      fundPayableList: {
        get() {
          const arr = this.feeInfoList || [];
          const { exchangeRate, currencyName } = this.feeInfo;
          arr.forEach((i) => {
            i.exchangeRate = exchangeRate || i.exchangeRate;
            i.currencyName = currencyName || i.currencyName;
          });
          return arr;
        },
        set(val) {
          console.log(val);
        },
      },
    },
    watch: {},
    mounted() {
      console.log(this.$route.params);
      let objByOther = this.$route.params;
      this.getCompany();
      if (this.$route.query.query) {
        this.query = JSON.parse(this.$route.query.query);
        this.feeInfo.requestCompanyCode = this.query.payableInvoiceCompanyCode;
        this.feeInfo.payeeNo = this.query.invoiceUnitNo;
        this.feeInfo.payeeName = this.query.invoiceUnitName;
        // businessType 业务类别
        this.feeInfo = JSON.parse(JSON.stringify(this.feeInfo));
      }
      if (this.$route?.query?.businessType) {
        this.feeInfo.settlementBusinessType = this.$route?.query?.businessType;
        this.feeInfo.settlementBusinessTypeName = this.dictListMap?.businessCategoryPayable.find(
          (item) => item.value == this.$route?.query?.businessType
        )?.label;
        this.settlementBusinessTypeHandler(this.feeInfo.settlementBusinessType);
        this.canEditSettlementBusinessType = false;
      }
      // 判断是否从结算单创建
      if (!this.$utils.isEmpty(objByOther)) {
        this.feeInfo.sourceType = 'INVOICE';
        if (objByOther.isRelatedInstruction) {
          this.getDetailFromShipping(objByOther);
        } else {
          this.getDetailFromSettle(objByOther);
        }
      } else {
        this.feeInfo.sourceType = 'INPUT';
        if (this.$route.query.id) {
          this.getDetail(this.$route.query.id);
        } else {
          this.feeInfo.requestCompanyCode = this.userInfo.companyCode;
          this.feeInfo.requestCompanyName = this.userInfo.companyName;
          this.feeInfo.requestDepartmentCode = this.userInfo.departmentCode;
          this.feeInfo.requestDepartmentName = this.userInfo.departmentName;
          this.feeInfo.requestPersonNo = this.userInfo.userCode;
          this.feeInfo.requestPersonName = this.userInfo.userName;
          let formData = this.filterEmpty(this.feeInfo);
          this.$utils.lastObjectEach(formData, (item, key) => {
            this.$refs.feeInfo.formData[key] = item;
          });
          this.attachmentList = this.feeInfo.returnAttachmentList || [];
          this.$refs['feeInfo'].getdepartmentList(this.feeInfo.requestCompanyCode);
          this.$refs['feeInfo'].getLedger(this.feeInfo.requestCompanyCode);
        }
      }
    },
    methods: {
      submitTemporaryQuota() {
        let path = {
          path: `/project/projectTemporaryAdd`,
          name: `projectTemporaryAdd`,
          meta: {
            keepAlive: true,
            title: `项目额度新增`,
          },
          query: {
            isDetail: false,
            projectId: this.projectId,
            deficientLimit: this.deficientLimit,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      async generateAttachment() {
        let id = this.$route.query.id || this.id;
        let res = await this.$axios.get(`/financial/paymentApply/createByPayNo/${id}`);
        if (res.data.code == 0) {
          this.getDetail(id);
        } else {
          this.$message.error(res.data.msg);
        }
      },
      attachmentUpdate(list) {
        this.attachmentList = this.$refs.fileTableRef?.getTableData();
        console.log('updateSettle attachments', this.attachmentList, list);
        this.attachmentList = Array.from(this.attachmentList).concat(list);
      },
      settlementBusinessTypeHandler(val) {
        this.settlementBusinessType = val;
      },
      async assignAvailableAmount(projectInitiationNo) {
        if (projectInitiationNo) {
          let res = await this.$axios.post('/sales/creditLimitSummary/listProject', {
            quotaType: 'projectQuota',
            projectCodeList: [projectInitiationNo],
          });
          if (res.data.code == 0 && res.data.data?.length != 0) {
            let obj = res.data.data[0];
            if (obj) {
              return obj['availableAmount'];
            }
          } else {
            // this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }
        return null;
      },
      getPayapplyLine() {
        return this.$refs.payapplyLineInfo.$refs.firstClaim.getTableData().fullData;
      },
      async getDetailFromSettle(obj) {
        this.feeInfo = obj;
        this.id = null;
        this.feeInfo.currencyName = this.currencyList.find(
          (i) => i.value === this.feeInfo.currencyCode
        ).label;

        let formData = this.filterEmpty(this.feeInfo);
        XEUtils.lastObjectEach(formData, (item, key) => {
          this.$refs.feeInfo.formData[key] = item;
        });

        this.feeInfo.isVirtual = this.$refs.feeInfo.formData.isVirtual =
          this.feeInfo.isVirtual == '1';
        this.feeInfo.isPrepay = this.$refs.feeInfo.formData.isPrepay = this.feeInfo.isPrepay == '1';
        this.feeInfo.isMoreDeliverer = this.$refs.feeInfo.formData.isMoreDeliverer =
          this.feeInfo.isMoreDeliverer == '1';
        this.feeInfo.isRelatedInstruction = this.$refs.feeInfo.formData.isRelatedInstruction =
          this.feeInfo.isRelatedInstruction == '1';

        this.feeInfoList = this.feeInfo.fundPaymentApplyDetailList;
        this.feeInfoList = await Promise.all(
          this.feeInfoList.map((item) => {
            return (async () => {
              item.paidAccountedAmount = 0;
              item.paidAmount = 0;

              let projectInitiationNo = item.projectInitiationNo || item.projectCode;
              if (projectInitiationNo) {
                item.availableAmount = await this.assignAvailableAmount(projectInitiationNo);
              }
              return item;
            })();
          })
        );
        this.requestCompanyCode = obj.requestCompanyCode;
        this.attachmentList = this.feeInfo.returnAttachmentList || [];
        this.$refs['feeInfo'].getdepartmentList(this.feeInfo.requestCompanyCode);
        this.$refs['feeInfo'].getBankInfo(this.feeInfo.payeeNo, this.requestCompanyCode); //因为部门未知，所以建议查询改供应商所有
      },
      //清空票据信用证列表（0清空所有，1清空票据，2清空信用证）
      clearBillCertList(type = 0) {
        this.$refs.billCertListRef?.clear(type);
      },
      async getDetailFromShipping(obj) {
        this.id = null;
        this.feeInfo = obj;
        this.feeInfo.currencyName = this.currencyList.find(
          (i) => i.value === this.feeInfo.currencyCode
        ).label;

        this.settlementBusinessType = '05';
        this.feeInfo.settlementBusinessType = '05'; //业务类别默认城矿05
        this.feeInfo.settlementBusinessTypeName = '城矿'; //业务类别默认城矿05
        this.attachmentList = this.feeInfo.returnAttachmentList || [];
        let formData = this.filterEmpty(this.feeInfo);
        XEUtils.lastObjectEach(formData, (item, key) => {
          this.$refs.feeInfo.formData[key] = item;
        });

        this.feeInfo.isVirtual = this.$refs.feeInfo.formData.isVirtual =
          this.feeInfo.isVirtual == '1';
        this.feeInfo.isPrepay = this.$refs.feeInfo.formData.isPrepay = this.feeInfo.isPrepay == '1';
        this.feeInfo.isMoreDeliverer = this.$refs.feeInfo.formData.isMoreDeliverer =
          this.feeInfo.isMoreDeliverer == '1';
        this.feeInfo.isRelatedInstruction = this.$refs.feeInfo.formData.isRelatedInstruction =
          this.feeInfo.isRelatedInstruction == '1';

        this.feeInfoList = this.feeInfo.fundPaymentApplyDetailList;
        this.feeInfoList = await Promise.all(
          this.feeInfoList.map((item) => {
            return (async () => {
              item.paidAccountedAmount = 0;
              item.paidAmount = 0;

              let projectInitiationNo = item.projectInitiationNo || item.projectCode;
              if (projectInitiationNo) {
                item.availableAmount = await this.assignAvailableAmount(projectInitiationNo);
              }
              return item;
            })();
          })
        );
        this.requestCompanyCode = obj.requestCompanyCode;
        this.$refs['feeInfo'].getdepartmentList(this.feeInfo.requestCompanyCode);
        this.$refs['feeInfo'].getBankInfo(this.feeInfo.payeeNo, this.requestCompanyCode); //因为部门未知，所以建议查询改供应商所有
      },
      // 获取详情信息
      getDetail(id = this.$route.query.id) {
        this.id = id;
        loading.startLoading();
        this.$axios
          .get(`${APLAY_LIST.GET_PAYMENT_APPLY_DETAIL}/${id}`)
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              // 如果是拷贝的则清空部门字段
              let requestInfo = res.data.data;
              if (this.$route.query.flag == 'copy') {
                requestInfo.id = null;
                requestInfo.attachmentList = null;
                requestInfo.createBy = null;
                requestInfo.gmtCreate = null;
                requestInfo.paymentApplyNumber = null;
                requestInfo.requestStatus = null;
                requestInfo.requestPersonNo = this.userInfo.userCode;
                requestInfo.requestPersonName = this.userInfo.userName;
                requestInfo.returnAttachmentList = null;
                requestInfo.unpaidAccountedAmount = requestInfo.requestAccountedAmount;
                requestInfo.unpaidAmount = requestInfo.requestAmount;
                requestInfo.paidAmount = 0;
                requestInfo.paidAccountedAmount = 0;
                requestInfo.fundPaymentApplyDetailList.map((item) => {
                  item.id = null;
                  item.createBy = null;
                  item.gmtCreate = null;
                  item.paidAccountedAmount = 0;
                  item.paidAmount = 0;
                  item.unpaidAmount = item.requestAmount;
                  item.unpaidAccountedAmount = item.requestAccountedAmount;
                  return item;
                });
              }

              this.feeInfo = requestInfo;

              //测试代码 提交删除
              // this.feeInfo.isRelatedInstruction = '1'

              this.feeInfo.isVirtual = this.feeInfo.isVirtual == '1';
              this.feeInfo.isPrepay = this.feeInfo.isPrepay == '1';
              this.feeInfo.isMoreDeliverer = this.feeInfo.isMoreDeliverer == '1';
              this.feeInfo.isRelatedInstruction = this.feeInfo.isRelatedInstruction == '1';
              this.feeInfo.currencyName = this.currencyList.find(
                (i) => i.value === this.feeInfo.currencyCode
              ).label;
              let formData = this.filterEmpty(this.feeInfo);
              XEUtils.lastObjectEach(formData, (item, key) => {
                this.$refs.feeInfo.formData[key] = item;
              });
              this.feeInfoList = this.feeInfo.fundPaymentApplyDetailList;
              this.requestCompanyCode = requestInfo.requestCompanyCode;
              //刷新行信息业务类型取值
              this.settlementBusinessTypeHandler(requestInfo.settlementBusinessType);
              this.attachmentList = this.feeInfo.returnAttachmentList || [];
              this.$refs['feeInfo'].getdepartmentList(this.feeInfo.requestCompanyCode);
              this.$refs['feeInfo'].getBankInfo(
                this.feeInfo.payeeNo,
                this.feeInfo.requestCompanyCode
              );
              this.queryDeductionDetail();
              this.payOrderDetailList = this.feeInfo.paymentInfoList;
              if (this.feeInfo.paymentStatus == 'Saved') {
                this.canEdit = false;
              }

              this.$nextTick(() => {
                //写入票据信息
                if (
                  requestInfo.fundPaymentApplyOtherInfoList &&
                  requestInfo.fundPaymentApplyOtherInfoList.length != 0
                ) {
                  this.$refs.billCertListRef?.importTableData(
                    requestInfo.fundPaymentApplyOtherInfoList
                  );
                }
              });
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => loading.endLoading());
      },
      // 获取夫妇看抵扣情况
      queryDeductionDetail() {
        if (!this.canEdit) {
          this.$axios
            .post(`${APLAY_LIST.QUERY_DEDUCTION_DETAIL}`, {
              paymentApplyNumber: this.feeInfo.paymentApplyNumber,
            })
            .then((res) => {
              loading.endLoading();
              if (0 == res.data.code) {
                this.deductionInfoList = res.data.data;
              } else {
                this.$alert(res.data.msg);
              }
            })
            .catch();
        }
      },
      //获取公司信息
      async getCompany() {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personCompanyInfo = selectStatus.data.data.personCompanyInfo || [];
          if (personCompanyInfo[0]) {
            this.companyList = personCompanyInfo.map((it) => {
              return { value: it.personCompanyCode, label: it.personCompanyName };
            });
          }
        }
      },
      //更新表单信息
      updateForm(formData) {
        this.feeInfo = { ...this.feeInfo, ...formData };
      },

      // //更新附件列表
      // uploadList(value) {
      //   this.attachmentList = [];
      //   if (value.length) {
      //     value.map((item) => {
      //       this.attachmentList.push({
      //         ...item,
      //       });
      //     });
      //   }
      // },
      // 重置行信息
      resetRowInfo() {
        this.feeInfoList = [];
      },
      // 校验付款申请表单
      validateForm() {
        return new Promise((resolve) => {
          this.$refs.feeInfo.$refs.formData
            .handleSubmit()
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              this.$message.error('请检查付款申请表单填写');
            });
        });
      },
      // 获取发票号列表
      getInvoiceCodes(list) {
        this.invoiceCodeList = list.map((i) => {
          i = { label: i, value: i };
          return i;
        });
      },
      // 更新发票头部信息
      updateBillInfo(obj) {
        if (!obj && !this.$route?.query?.businessType) {
          this.canEditSettlementBusinessType = true;
        } else {
          this.feeInfo = JSON.parse(JSON.stringify(Object.assign(this.feeInfo, obj)));
          let formData = this.filterEmpty(this.feeInfo);
          XEUtils.lastObjectEach(formData, (item, key) => {
            this.$refs.feeInfo.formData[key] = item;
          });
          this.canEditSettlementBusinessType = false;
        }
      },

      // 编辑
      edit() {
        this.canEdit = true;
        // this.getLastDepart(this.companyTree.find(i=>i.id===this.invoiceInfo.invoiceCompanyCode).children)
      },
      // 保存
      async save(isSaveSuccess) {
        console.log('进入保存1', isSaveSuccess);

        isSaveSuccess = isSaveSuccess == true ? isSaveSuccess : false;

        const {
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          tenantCode,
          businessGroup,
        } = this.userInfo;
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;
        let fundPaymentApplyDetailList = await this.$refs['payapplyLineInfo'].exportChildData();
        if (fundPaymentApplyDetailList.length == 0) {
          this.$message({ showClose: true, type: 'error', message: '请添加行信息' });
          return;
        }
        let requestAmount = this.feeInfo.requestAmount;
        fundPaymentApplyDetailList.map((item) => {
          requestAmount = this.$cal.calCommon(requestAmount, item.requestAmount, '-');
        });
        console.log(requestAmount);
        if (requestAmount !== 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '行信息申请金额合计不等于主表申请金额',
          });
          return;
        }
        fundPaymentApplyDetailList.forEach((i, index) => {
          i.saveUpdate = 1;
          i.lineNumber = index + 1;
          i.tenantCode = tenantCode;
          i.companyCode = companyCode;
          i.companyName = companyName;
          i.departmentCode = departmentCode;
          i.departmentName = departmentName;
          for (var attr in i) {
            //在遍历对象判断是null并且设置为想要的值
            if (!i[attr]) i[attr] = '';
          }
          if (Object.prototype.hasOwnProperty.call(i, 'departmentCodes'))
            delete i['departmentCodes'];
        });

        //处理信用证票据表
        if (this.$refs.billCertListRef) {
          let billCertValid = this.$refs.billCertListRef.validateByPaymentMethod();
          if (!billCertValid) {
            return;
          }
        }
        let billCertList = [];

        if (this.$refs.billCertListRef) {
          billCertList = this.$refs.billCertListRef.exportTableData();
          if (billCertList && billCertList.length != 0) {
            billCertList = billCertList.map((item) => {
              return { ...item, companyCode, companyName, departmentCode, departmentName };
            });
          }
        }

        // 附件
        const attachmentList = this.$refs.fileTableRef?.getTableData();
        let params = {
          ...this.feeInfo,
          fundPaymentApplyOtherInfoList: billCertList,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          tenantCode,
          businessGroup,
          //
          fundPaymentApplyDetailList: fundPaymentApplyDetailList,
          isVirtual: this.feeInfo.isVirtual ? '1' : '0',
          isPrepay: this.feeInfo.isPrepay ? '1' : '0',
          isMoreDeliverer: this.feeInfo.isMoreDeliverer ? '1' : '0',
          isRelatedInstruction: this.feeInfo.isRelatedInstruction ? '1' : '0',
          attachmentList: attachmentList,
          currencyName: this.currencyList.find((i) => i.value === this.feeInfo.currencyCode).label,
        };

        delete params.returnAttachmentList;
        console.log('isSaveSuccess', isSaveSuccess);
        await this.saveData(params, isSaveSuccess);
      },
      async saveData(params, isSaveSuccess) {
        isSaveSuccess = isSaveSuccess || false;
        loading.startLoading();
        let res = await this.$axios.post(APLAY_LIST.PAYMENT_APPLY_SAVE, params);
        loading.endLoading();
        console.log('isSaveSuccess', isSaveSuccess);
        if (!isSaveSuccess) {
          if (res) {
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('billDetail.message.saveSussess'),
              });
              if (this.$route.query.flag == 'copy') {
                this.goEdit(res.data.data.id);
              } else {
                this.getDetail(res.data.data.id);
              }
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          } else {
            // loading.endLoading();
          }
        }
        console.log('保存结果', res);
        // this.isSaveSuccess = res.data.code;
      },
      // 提交审批
      async submitApproval() {
        // const { paymentType, requestAmount, availableCreditAmount } = this.feeInfo;
        /* if(paymentType==="PT01" && requestAmount>availableCreditAmount){
            this.$message({ showClose: true, message: '超出可用信用额度，无法提交', type: "error" });
            return
          }  */

        let flag = await this.validateForm(); //校验表单
        if (!flag) return;
        const {
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          tenantCode,
          businessGroup,
        } = this.userInfo;
        let fundPaymentApplyDetailList = await this.$refs['payapplyLineInfo'].exportChildData();
        if (fundPaymentApplyDetailList.length == 0) {
          this.$message({ showClose: true, type: 'error', message: '请添加行信息' });
          return;
        }
        let requestAmount = this.feeInfo.requestAmount;
        fundPaymentApplyDetailList.map((item) => {
          requestAmount = this.$cal.calCommon(requestAmount, item.requestAmount, '-');
        });
        console.log(requestAmount);
        if (requestAmount !== 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '行信息申请金额合计不等于主表申请金额',
          });
          return;
        }
        fundPaymentApplyDetailList.forEach((i, index) => {
          i.saveUpdate = i.id || i.id === 0 ? 2 : 1;
          i.lineNumber = index + 1;
          i.tenantCode = tenantCode;
          i.companyCode = companyCode;
          i.companyName = companyName;
          i.departmentCode = departmentCode;
          i.departmentName = departmentName;
        });
        fundPaymentApplyDetailList = fundPaymentApplyDetailList.concat(this.delList);
        const attachmentList = this.$refs.fileTableRef?.getTableData();

        //处理信用证票据表
        if (this.$refs.billCertListRef) {
          let billCertValid = this.$refs.billCertListRef.validateByPaymentMethod();
          if (!billCertValid) {
            return;
          }
        }

        let billCertList = [];
        if (this.$refs.billCertListRef) {
          billCertList = this.$refs.billCertListRef.exportTableData();
          if (billCertList && billCertList.length != 0) {
            billCertList = billCertList.map((item) => {
              return { ...item, companyCode, companyName, departmentCode, departmentName };
            });
          }
        }
        let params = {
          ...this.feeInfo,
          fundPaymentApplyOtherInfoList: billCertList,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          tenantCode,
          businessGroup,
          fundPaymentApplyDetailList,
          changePayableInvoiceCompanyCode: !(
            this.requestCompanyCode === this.feeInfo.requestCompanyCode
          ),
          isVirtual: this.feeInfo.isVirtual ? '1' : '0',
          isPrepay: this.feeInfo.isPrepay ? '1' : '0',
          isMoreDeliverer: this.feeInfo.isMoreDeliverer ? '1' : '0',
          isRelatedInstruction: this.feeInfo.isRelatedInstruction ? '1' : '0',
          attachmentList: attachmentList,
          currencyName: this.currencyList.find((i) => i.value === this.feeInfo.currencyCode).label,
        };

        delete params.returnAttachmentList;

        loading.startLoading();
        let saveData = {
          ...params,
          saveUpdate: 2,
        };
        // 提交前保存
        if (params.id) {
          let isSaveSuccess = true;
          await this.save(isSaveSuccess);
        }

        // 提交前校验
        const { data } = await this.$axios.post(APLAY_LIST.BEFORE_CHECK, saveData);
        loading.endLoading();
        console.log('校验数据', data);
        // let isSubmit = true;
        if (data.data) {
          await this.$confirmAction('确认', data.data + ',是否继续？')
            .then(() => {
              console.log('继续');
              this.submitApproval1(saveData);
            })
            .catch(() => {
              // isSubmit = false;
              return;
            });
        } else {
          this.submitApproval1(saveData);
        }
      },
      async submitApproval1(saveData) {
        this.$axios
          .post(APLAY_LIST.BEFORE_SUBMIT, saveData)
          .then((res) => {
            if (res.data.code === 0) {
              this.submitApprovalData(saveData);
            } else if (res.data.code === 9) {
              this.$confirmAction('提示', res.data.msg)
                .then(() => {
                  this.submitApprovalData(saveData);
                })
                .catch(() => {
                  loading.endLoading();
                  this.$message({
                    showClose: true,
                    type: 'info',
                    message: '取消提交',
                  });
                });
            } else {
              if (res.data.data === 'Freeze') {
                this.canEdit = false;
              }
              loading.endLoading();
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              const startIndex = res.data.msg.indexOf('[') + 1;
              const endIndex = res.data.msg.indexOf(']');
              var limitList = res.data.msg.match(/\d+(\.\d+)?/g); //['编号','金额'] 匹配出两串数字
              if (limitList != null && limitList.length > 1) {
                this.deficientLimit = limitList[1];
              }
              this.projectId = res.data.msg.substring(startIndex, endIndex);
              // console.log('this.projectId', this.projectId, this.deficientLimit);
            }
          })
          .catch(() => loading.endLoading());
      },
      //校验结束后提交
      submitApprovalData(saveData) {
        this.$axios
          .post(APLAY_LIST.SUBMIT2_APPROVAL, saveData)
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.$message({ showClose: true, message: '提交审批成功', type: 'success' });
              this.goBack();
            } else if (res.data.code === 10) {
              // 弱管控 二次确认提交
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.submitApprovalData({ ...saveData, cancelValidate: true });
                },
              });
            } else {
              if (res.data.data && res.data.data.id) {
                // 保存成功，但是提交oa失败
                // 刷新状态，防止多次提交重复数据
                this.getDetail(res.data.data.id);
              }
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .catch(() => loading.endLoading());
      },
      // 批准
      approve() {
        const params = {
          ...this.feeInfo,
          isVirtual: this.feeInfo.isVirtual ? '1' : '0',
          isPrepay: this.feeInfo.isPrepay ? '1' : '0',
          isMoreDeliverer: this.feeInfo.isMoreDeliverer ? '1' : '0',
          isRelatedInstruction: this.feeInfo.isRelatedInstruction ? '1' : '0',
        };
        loading.startLoading();
        this.$axios
          .post(APLAY_LIST.PASS, params)
          .then((res) => {
            loading.endLoading();
            if (res.data.code == 0) {
              this.goBack();
            }
          })
          .catch(() => loading.endLoading());
      },
      // 撤回
      async doWithdraw() {
        let params = {
          //撤回所需参数
          id: this.feeInfo.id,
          businessGroup: this.userInfo.businessGroup,
        };
        this.$confirmAction('确认更改？', '是否确认撤回？')
          .then(async () => {
            this.loading.startLoading();
            const res = await this.$axios.post(APLAY_LIST.WITHDRAW, params);
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.getDetail(this.feeInfo.id);
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 提交付款
      submitPayment() {
        const { version } = this.feeInfo;
        loading.startLoading();
        this.$axios
          .post(APLAY_LIST.SUBMIT2_PAYMENT, {
            id: this.$route.query.id,
            version,
          })
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.goBack();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .catch(() => loading.endLoading());
      },
      // 申请关闭填写原因
      handleApplyClose() {
        this.$prompt('申请关闭', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入关闭原因',
        })
          .then(({ value }) => {
            this.applyClose(value);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入',
            });
          });
      },
      // 生成付款单
      createPayment() {
        let path = {
          path: '/payment/paymentAdd',
          name: 'paymentAdd',
          query: { ids: this.feeInfo.id },
          meta: {
            keepAlive: true,
            title: '付款单创建',
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 申请关闭
      applyClose(closeReason) {
        loading.startLoading();
        this.$axios
          .post(APLAY_LIST.APPLY_CLOSE, {
            id: this.$route.query.id,
            closeReason,
            version: this.feeInfo.version,
          })
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.goBack();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .catch(() => loading.endLoading());
      },
      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
            },
          },
          toPath: {
            path: '/payment/paymentApplyList',
            name: 'paymentApplyList',
            meta: {
              keepAlive: false,
              title: this.$t('currenciesAndCalendar.addCurrencies.queryCurrencies'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      // 复制保存成功跳转编辑页面
      goEdit(id) {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: false,
              title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
            },
          },
          toPath: {
            path: '/payment/paymentApplyDetailCK',
            name: 'paymentApplyDetailCK',
            meta: {
              keepAlive: true,
              title: '付款申请单详情',
            },
            query: { id: id, isEdit: 'N' },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
</style>
